export const MONOGRAM_TEST_IDS = {
  // Common
  CONTAINER: 'monogram-container',
  HEADER: 'monogram-header',
  PANEL_CONFIRM_BTN: 'monogram-panel-confirm-btn',
  POSITION_LIST: 'monogram-position-list',
  REMOVE_MODAL: 'monogram-remove-modal',
  ALLOWED_NUMBER_MODAL: 'monogram-allowed-number-modal',

  // Position dynamic IDs
  getPositionId: (positionId: number) => `monogram-position-${positionId}-id`,
  getPositionName: (positionId: number) => `monogram-position-${positionId}-name`,
  getPositionDescription: (positionId: number) => `monogram-position-${positionId}-description`,
  getPositionEdit: (positionId: number) => `monogram-position-${positionId}-edit`,
  getPositionDelete: (positionId: number) => `monogram-position-${positionId}-delete`,

  // Monogram Details Panel
  DETAILS_TITLE: 'monogram-details-title',
  DETAILS_BACK_BTN: 'monogram-details-back-btn',
  INITIALS_INPUT: 'monogram-initials-txt',
  COLOR_LIST: 'monogram-color-list',
  FONT_LIST: 'monogram-font-list',
  APPLY_BTN: 'monogram-apply-btn',

  // Details tile dynamic IDs
  getColorTileId: (colorId: number) => `monogram-color-tile-${colorId}`,
  getFontTileId: (fontStyleId: number) => `monogram-font-tile-${fontStyleId}`,
} as const;

